<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section logo-section">
          <div class="footer-logo">
            <img src="../assets/logo.png" alt="隆之智环保" class="footer-logo-image">
          </div>
        </div>
        <div class="footer-section services">
          <h3>关注我们</h3>
          <div class="qrcode">
            <img :src="require('../assets/26.png')" alt="关注我们二维码" class="qrcode-image">
            <p>扫码关注我们</p>
          </div>
        </div>
        <div class="footer-section contact">
          <h3>联系我们</h3>
          <p>地址：山东淄博市经开区华光路西首777号齐鲁数谷1号楼6层</p>
          <p>电话：0533-3584808</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>Copyright © 2016 山东隆之智环保科技有限公司 版权所有  鲁ICP备16007350号-1   技术支持：隆之智环保</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background-color: #333;
  color: #fff;
  padding: 40px 0;
  margin-top: 50px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 50px;
}

.footer-section {
  flex: 1;
  min-width: 250px;
  margin-bottom: 30px;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .footer-section {
    flex: 0 0 100%;
    max-width: 100%;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .footer {
    padding: 30px 0;
  }

  .footer-section h3 {
    font-size: 16px;
  }

  .footer-section p,
  .footer-section ul li {
    font-size: 14px;
  }

  .footer-bottom p {
    font-size: 12px;
  }
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #42b983;
}

.footer-section p {
  margin-bottom: 10px;
  line-height: 1.6;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}

.footer-section ul li:hover {
  transform: translateX(5px);
  color: #42b983;
}

.qrcode {
  text-align: center;
}

.qrcode-image {
  width: 120px;
  height: 120px;
  margin-bottom: 10px;
  border: 2px solid #42b983;
  border-radius: 8px;
}

.qrcode p {
  margin-top: 10px;
  font-size: 14px;
  color: #42b983;
}

.footer-logo {
  margin-bottom: 20px;
  text-align: center;
}

.footer-logo-image {
  width: 200px;
  height: auto;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.footer-logo-image:hover {
  transform: scale(1.05);
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #444;
}
</style>